export const CURRENT_TEMPSETTING_SET_APPBASEPATH = "CURRENT_TEMPSETTING_SET_APPBASEPATH";
